
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.455 0a2.184 2.184 0 00-2.182 2.182v5.454H2.182A2.181 2.181 0 000 9.818v5.455c0 1.205.976 2.182 2.182 2.182h1.09v2.181c0 1.204.98 2.182 2.183 2.182h7.636v-2.182H5.455v-2.181h8.914l6.358-6.358V5.455L15.273 0H5.455zM3.57 9.818l.79 1.873.793-1.873h1.36L5.13 12.522l1.414 2.75H5.17l-.807-1.906-.804 1.907H2.182l1.412-2.751L2.21 9.818H3.57zm5.156 0v4.364h2.182v1.09H7.636V9.819h1.091zm4.899 0c1.552.045 1.647 1.4 1.647 1.64h-1.057v-.07c-.007-.203-.065-.69-.61-.69-.19 0-.618.085-.585.612.031.483.667.711.784.762.244.09 1.454.629 1.463 1.728.003.234-.058 1.456-1.621 1.473-1.7.018-1.815-1.445-1.815-1.747h1.063c0 .16.013.935.752.875.444-.037.54-.356.556-.594.025-.4-.357-.641-.76-.835-.568-.273-1.465-.608-1.481-1.67-.015-.958.688-1.511 1.664-1.484zm.556-7.636v4.363h4.363v1.091H5.455V2.182h8.727zm5.454 13.09l-4.363 4.364h3.272V24h2.182v-4.364H24l-4.364-4.363z","fill":"#151515","fill-rule":"evenodd"}})])
          )
        }
      }
    